<h4 class="pl-1 title" attr.title="{{ card.Name }}">
  {{ card.Name }}
  <i class="travel-icon icon-star" aria-hidden="true" *ngFor="let Star of starsArr; let Si = index"></i>
</h4>
<div class="clearfix"></div>
<small class="pl-1 address">{{ card.AddressFirst }}</small>
<div class="clearfix"></div>
